import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { useState } from "react";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import DashboardLayout from "../layout";
import EstimateForm from "../forms/EstimateForm";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { api, API_BASE_URL } from "../../config/api";
import { useMyContext } from "../../context/MyContext";
import { toast } from "react-toastify";

function Calculator() {
  const obj = {
    ative: true,
    content: "IOR Calculator",
  };

  const { user } = useMyContext();

  const navigate = useNavigate();
  const [showEstimateForm, setShowEstimateForm] = useState(true);
  const [selectedEstimate, setSelectedEstimate] = useState(null);
  const [isNewEstimate, setIsNewEstimate] = useState(true);
  const [estimates, setEstimates] = useState([]);

  const handleBackFromForm = () => {
    setShowEstimateForm(false);
    setSelectedEstimate(null);
    setIsNewEstimate(false);
    navigate("/bookshipment?tab=proposal");
  };

  const fetchEstimates = async () => {
    if (user?.uid) {
      try {
        const response = await api.get(
          `${API_BASE_URL}/clientestimates/user/${user.uid}`
        );
        setEstimates(
          response.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );
      } catch (error) {
        console.error("Error fetching estimates:", error);
        toast.error("Error fetching estimates");
      }
    }
  };

  return (
    <>
      <DashboardLayout>
        <div className="w-full border border-red">
          <Header title="IOR Calculator" />
          <EstimateForm
            onBack={handleBackFromForm}
            estimate={selectedEstimate}
            fetchEstimates={fetchEstimates}
            isNewEstimate={isNewEstimate}
          />
        </div>
      </DashboardLayout>
    </>
  );
}

export default Calculator;